import React from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
// Import team images from assets
import sunilImage from '../../assets/images/sunil3.jpg';
import directorImage from '../../assets/images/director2.jpg';

const OurTeam = () => {
  const teamData = {
    hero: {
      title: 'Meet Our Team',
      subtitle: 'Dedicated Professionals Committed to Sustainable Agriculture',
      description: 'Our experienced team of agricultural experts, farm managers, and sustainability specialists working together to create exceptional farming experiences and build lasting relationships with our farming community.',
    },
    members: [
      {
        id: 1,
        name: 'Sunil Kumar S',
        position: 'Founder & Agricultural Director',
        description: 'Visionary leader with over 15 years of experience in sustainable agriculture and sandalwood cultivation.',
        email: 'sunil@siridharini.com',
        phone: '+91 9036024568',
        image: sunilImage,
        specialties: ['Sandalwood Cultivation', 'Sustainable Farming', 'Agricultural Innovation']
      },
      {
        id: 2,
        name: 'Roopa Sunil Kumar',
        position: 'Co-Founder & Operations Manager',
        description: 'Expert in farm operations management and sustainable agricultural practices with focus on organic farming.',
        email: 'roopa@siridharini.com',
        phone: '+91 9448472706',
        image: directorImage,
        specialties: ['Organic Farming', 'Farm Operations', 'Quality Management']
      },
      {
        id: 3,
        name: 'Agricultural Team',
        position: 'Farm Management Specialists',
        description: 'Dedicated team of agricultural experts ensuring optimal crop health and farm productivity.',
        email: 'farm@siridharini.com',
        phone: '+91 9036024568',
        image: sunilImage,
        specialties: ['Crop Management', 'Soil Health', 'Pest Control']
      },
      {
        id: 4,
        name: 'Sustainability Team',
        position: 'Environmental Conservation Specialists',
        description: 'Committed professionals focused on environmental conservation and sustainable farming practices.',
        email: 'sustainability@siridharini.com',
        phone: '+91 9036024568',
        image: directorImage,
        specialties: ['Environmental Conservation', 'Water Management', 'Biodiversity']
      }
    ]
  };

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    },
    heroSection: {
      background: 'linear-gradient(135deg, #2d5016 0%, #22c55e 100%)',
      color: 'white',
      padding: '100px 0',
      textAlign: 'center'
    },
    heroContent: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '0 2rem'
    },
    heroTitle: {
      fontSize: '3.5rem',
      fontWeight: 'bold',
      marginBottom: '1rem',
      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    heroSubtitle: {
      fontSize: '1.5rem',
      marginBottom: '1.5rem',
      opacity: '0.9'
    },
    heroDescription: {
      fontSize: '1.1rem',
      opacity: '0.8',
      lineHeight: '1.8'
    },
    teamSection: {
      padding: '80px 0',
      backgroundColor: '#fff'
    },
    sectionContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem'
    },
    teamGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '3rem',
      marginTop: '3rem'
    },
    memberCard: {
      backgroundColor: '#fff',
      borderRadius: '15px',
      padding: '2rem',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease',
      border: '2px solid transparent'
    },
    memberImage: {
      width: '120px',
      height: '120px',
      borderRadius: '50%',
      objectFit: 'cover',
      margin: '0 auto 1.5rem',
      display: 'block',
      border: '4px solid #22c55e'
    },
    memberName: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '0.5rem',
      color: '#2d5016',
      textAlign: 'center'
    },
    memberPosition: {
      fontSize: '1.1rem',
      color: '#f97316',
      fontWeight: '600',
      marginBottom: '1rem',
      textAlign: 'center'
    },
    memberDescription: {
      fontSize: '1rem',
      color: '#666',
      marginBottom: '1.5rem',
      lineHeight: '1.6',
      textAlign: 'center'
    },
    contactInfo: {
      borderTop: '1px solid #eee',
      paddingTop: '1rem',
      marginTop: '1rem'
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '0.5rem',
      fontSize: '0.9rem',
      color: '#666'
    },
    contactIcon: {
      marginRight: '0.5rem',
      color: '#22c55e'
    },
    specialties: {
      marginTop: '1rem'
    },
    specialtyTag: {
      display: 'inline-block',
      backgroundColor: '#f0f9ff',
      color: '#2d5016',
      padding: '0.3rem 0.8rem',
      borderRadius: '15px',
      fontSize: '0.8rem',
      margin: '0.2rem',
      border: '1px solid #22c55e'
    },
    statsSection: {
      backgroundColor: '#2d5016',
      color: 'white',
      padding: '60px 0',
      textAlign: 'center'
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '2rem',
      maxWidth: '800px',
      margin: '2rem auto 0'
    },
    statNumber: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#22c55e',
      marginBottom: '0.5rem'
    },
    statLabel: {
      fontSize: '1rem',
      opacity: '0.9'
    }
  };

  return (
    <div style={styles.container}>
      <Header />
      
      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>{teamData.hero.title}</h1>
          <h2 style={styles.heroSubtitle}>{teamData.hero.subtitle}</h2>
          <p style={styles.heroDescription}>{teamData.hero.description}</p>
        </div>
      </section>

      {/* Team Members Section */}
      <section style={styles.teamSection}>
        <div style={styles.sectionContainer}>
          <div style={styles.teamGrid}>
            {teamData.members.map((member) => (
              <div key={member.id} style={styles.memberCard}>
                <img 
                  src={member.image} 
                  alt={member.name}
                  style={styles.memberImage}
                />
                <h3 style={styles.memberName}>{member.name}</h3>
                <p style={styles.memberPosition}>{member.position}</p>
                <p style={styles.memberDescription}>{member.description}</p>
                
                <div style={styles.contactInfo}>
                  <div style={styles.contactItem}>
                    <span style={styles.contactIcon}>📧</span>
                    {member.email}
                  </div>
                  <div style={styles.contactItem}>
                    <span style={styles.contactIcon}>📞</span>
                    {member.phone}
                  </div>
                </div>

                <div style={styles.specialties}>
                  {member.specialties.map((specialty, index) => (
                    <span key={index} style={styles.specialtyTag}>
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Stats */}
      <section style={styles.statsSection}>
        <div style={styles.sectionContainer}>
          <h2 style={{fontSize: '2.5rem', marginBottom: '1rem'}}>Our Team's Impact</h2>
          <p style={{fontSize: '1.1rem', opacity: '0.8', marginBottom: '2rem'}}>
            Dedicated professionals committed to sustainable agriculture and environmental conservation
          </p>
          <div style={styles.statsGrid}>
            <div>
              <div style={styles.statNumber}>15+</div>
              <div style={styles.statLabel}>Years of Experience</div>
            </div>
            <div>
              <div style={styles.statNumber}>500+</div>
              <div style={styles.statLabel}>Acres Managed</div>
            </div>
            <div>
              <div style={styles.statNumber}>100%</div>
              <div style={styles.statLabel}>Organic Practices</div>
            </div>
            <div>
              <div style={styles.statNumber}>24/7</div>
              <div style={styles.statLabel}>Farm Monitoring</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OurTeam;